import { Upload } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Button, Typography } from 'components/index';
import React from 'react';
import { useDropzone } from 'react-dropzone';

interface Accept {
  [key: string]: string[];
}

interface Props {
  onDrop: (files: File[]) => void;
  accept: Accept;
  multiple?: boolean;
  fileTitle?: string;
  additionalStyles?: React.CSSProperties;
}

const Dropzone: React.FC<Props> = ({ onDrop, accept, multiple = false, fileTitle, additionalStyles }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple,
  });

  const acceptedExtensions = Object.values(accept).flat();
  const fileText = (fileTitle || 'File') + (multiple ? 's' : '');

  return (
    <div style={{ ...styles.dropzoneDiv, ...additionalStyles }} {...getRootProps()}>
      <input className='dropzone-input' {...getInputProps()} />
      <div className='text-center' style={{ margin: 'auto' }}>
        <div className='dropzone-content'>
          {isDragActive ? (
            <span>Release to drop the {fileText} here</span>
          ) : (
            <>
              <Box sx={{ my: '5px', color: 'GrayText' }}>
                <Upload fontSize='large' />
              </Box>
              <Typography sx={{ my: '5px' }} variant='body1'>
                Drag & Drop to Upload {fileText}
              </Typography>
              <Typography sx={{ my: '5px' }} variant='body2'>
                OR
              </Typography>
              <Button sx={{ my: '5px' }} variant='contained' color='primary' size='large' disableRipple>
                Browse {fileText}
              </Button>
              <Box sx={{ my: '10px', fontWeight: '400', fontSize: '12px', color: 'GrayText' }}>
                <Typography variant='body2'>Only {acceptedExtensions.join(', ')} files are accepted</Typography>
              </Box>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  dropzoneDiv: {
    border: '2px dashed #ccc',
    borderRadius: '5px',
    display: 'flex',
    placeItems: 'center',
    // height: '230px',
    width: '100%',
    padding: '25px',
    cursor: 'pointer',
  },
};

export default Dropzone;
